/* ******************************************************************** */
/*              Using Filter Results and Sort By buttons                */
/* ******************************************************************** */
import $, { isEmptyObject } from "jquery";
$(function () {
  let empArchive = {
    toggleFilters: function () {
      if ($("#archive-display-options-wrapper").hasClass("filters-expanded")) {
        $("#archive-display-options-wrapper").removeClass("filters-expanded");
        $("#archive-filter-expand").attr("aria-expanded", "false");
      } else {
        $("#archive-display-options-wrapper").addClass("filters-expanded");
        $("#archive-filter-expand").attr("aria-expanded", "true");
        let inputs = $("#archive-filters").find(
          "input:not([type=hidden]), select"
        );
        if (inputs) $(inputs[0]).trigger("focus");
      }
    },
  };

  $("#archive-display-options-wrapper").on(
    "click",
    "#archive-filter-expand, #hide-filters",
    function () {
      empArchive.toggleFilters();
    }
  );

  $(".archive-display-option").on("change", function () {
    var url = $(this).val();
    window.location.href = url;
  });

  $("#archive-current-filters").on("click", ".edit", function () {
    empArchive.toggleFilters();
    let relatedInputName = $(this).data("name");
    let relatedInputSelector = "[name=" + relatedInputName + "], [for=" + relatedInputName + "] + input, [for=" + relatedInputName + "] + * input";
    $(relatedInputSelector).trigger("focus");
  });
});

/* ******************************************************************** */
/*      Close Filter Results box when user clicks into searchbox        */
/* ******************************************************************** */
$(function () {
  $(".thunderberg-searchform").on("click", "input, button", function () {
    if ($("#archive-display-options-wrapper").hasClass("filters-expanded")) {
      $("#archive-display-options-wrapper").removeClass("filters-expanded");
      $("#archive-filter-expand").attr("aria-expanded", "false");
    }
  });
});

/* ******************************************************************** */
/*   Update search param in filters form when user edits the search     */
/* ******************************************************************** */
$(function () {
  $(".thunderberg-searchform").on("blur", "input", function () {
    $("#archive-filters-search-input").val($(this).val());
  });
});

/* ******************************************************************** */
/*          Toggle Date Inputs between Date Range and Month/Year        */
/* ******************************************************************** */
$(function () {
  $("#archive-filters").on("click", ".toggle-date-mode", function () {
    let $formGroup = $("#archive-filters .date-filter");
    if ($formGroup.hasClass("month-year-mode")) {
      $formGroup.addClass("date-range-mode").removeClass("month-year-mode");
      $("#archive-month, #archive-year").prop("disabled", "disabled");
      $("#archive-start-date, #archive-end-date").prop("disabled", false);
      $("#archive-start-date").trigger("focus");
      $(".date-filter-legend").text(
        "Date Inputs. Currently set to enter a start and end date."
      );
    } else {
      $formGroup.addClass("month-year-mode").removeClass("date-range-mode");
      $("#archive-month, #archive-year").prop("disabled", false);
      $("#archive-start-date, #archive-end-date").prop("disabled", "disabled");
      $("#archive-month").trigger("focus");
      $(".date-filter-legend").text(
        "Date Inputs. Currently set to enter month and year."
      );
    }
  });
});

/* ******************************************************************** */
/*             Clear visible date inputs in date filter                 */
/* ******************************************************************** */
$(function () {
  $("#archive-filters").on("click", ".clear-date-inputs", function () {
    let wrapper = $(this).closest(".date-filter-wrapper");
    if (wrapper) {
      wrapper.find("input, select").val("");
    }
  });
});

/* ******************************************************************** */
/* Dynamically update advanced search filters based on post type filter */
/* ******************************************************************** */
$(function () {
  $(".advanced-search #archive-filters").on(
    "change",
    "#page-type-filter",
    function () {
      let filterFormGroups = $("#archive-filters .form-group");
      let currentPostType = $("#page-type-filter").val();
      filterFormGroups.each(function () {
        let postTypeData = $(this).data("post-types");
        if (!postTypeData || postTypeData.includes("all")) {
          return true; // this is equivalent to "continue" in jQuery
        }
        // See if a matching post type was found
        let postTypes = postTypeData.split(/(\s+)/);
        let matchFound = false;
        postTypes.forEach((postType, i) => {
          if (currentPostType === postType) {
            matchFound = true;
          }
        });

        // If not match was found, this filter does not apply to the selected post type, so hide it
        if (matchFound) {
          $(this).removeClass("d-none");
          $(this).find("input, select").prop("disabled", false);
        } else {
          $(this).addClass("d-none");
          $(this).find("input, select").prop("disabled", "disabled");
        }
      });
    }
  );
});

/* ******************************************************************** */
/*                Update Search Form URL when Submitted                 */
/* ******************************************************************** */
$(function () {
  $(".thunderberg-searchform, .advanced-search #archive-filters").on('submit', function () {
    let form = $(this);
    let searchInput = form.find('input[name="s"]');
    if (!searchInput) {
      return; // in case the search input can't be found for some reason
    }
    let searchTerm = searchInput.val().trim();

    // if empty, redirect to archive page
    if (!searchTerm) {
      let archiveUrl = form.data('archive-url');
      if (archiveUrl) {
        form.attr('action', archiveUrl);
      }
    }
  });
});
